import { CountryCodeData } from "../../components/dialCodePicker";
import countryDataJson from '../assets/files/country_code_flag_number.json';

function findCountryByIsoOrDial(codeOrDial: any | undefined) {
  if (!codeOrDial) return undefined;
  const normalized = codeOrDial?.code?.trim()?.toUpperCase();
  return (countryDataJson as any[]).find(
    (c: any) => c.code?.toUpperCase() === normalized || c.number === codeOrDial
  );
}
 
const getCountryData = (userCountry: string, restaurantCountry?: string) => {
  const byUser = findCountryByIsoOrDial(userCountry);
  const byRestaurant = findCountryByIsoOrDial(restaurantCountry);
  const fallbackUS = findCountryByIsoOrDial('US');
 
  const chosen = byUser || byRestaurant || fallbackUS;
  const countryCodeData: CountryCodeData = {
    code: chosen?.number || '+1',
    flag:
      chosen?.flag ||
      'https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg',
  };
  return countryCodeData;
};
 
const getCountryFromCode = (code: string) => {
  const matched = (countryDataJson as any[]).find((c: any) => c.number === code);
  const countryCodeData: CountryCodeData = {
    code: matched?.number || '+1',
    flag:
      matched?.flag ||
      'https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg',
  };
  return countryCodeData;
};

export{
    getCountryData,
    getCountryFromCode
}